module.exports = __webpack_public_path__ + "static/media/faq-banner.8e0a2910.svg";